<template>
  <header class="container thankYouLayout__Header">
    <nuxt-link :to="link('Home')" class="thankYouLayout__Logo">
      <Icon name="logo" />
    </nuxt-link>

    <div class="thankYouLayout__DropdownWrapper">
      <button @click="open('contact')">
        <Icon name="phone" />
      </button>
    </div>
  </header>

  <Teleport to="body">
		<Modal v-show="dialogs.contact" v-model="dialogs.contact" class="modal__Contact">
			<ContactDropdown />
		</Modal>
	</Teleport>

  <slot />
  <CheckoutFooter class="thankYouLayout__Footer" />
</template>

<script setup>
  const { link } = useSetup();
  const dropdownVisible = ref(false);

  const dialogs = reactive({
		contact: false,
	});

  const { open } = useModal(dialogs);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_thankYouLayout.scss');
</style>